/* eslint-disable max-len */
import React from 'react'
import { Link } from 'react-router'
import Email from '../../containers/EmailContainer'
import Setting from '../../containers/SettingContainer'

export const Footer = () => (
  <footer className='footer-v2'>
    <div className='footer'>
      <div className='container'>
        <div className='row'>
          <div className='col-sm-3'>
            <div className='footer-widget widget-about'>
              <div className='widget-top'>
                <h3 className='widget-title'>Thông tin</h3>
              </div>
              <div className='widget-body'>
                <p>
                  {Setting.companyNameVAT}
                </p>
                <p>
                  {Setting.companyId}
                </p>
                <p>
                  {Setting.companyAddressVAT}
                </p>
                <p className='read'>
                  <Link to='chung-toi'>Chi tiết <i className='fa fa-caret-right' /></Link>
                </p>
              </div>
            </div>
          </div>
          <div className='col-sm-3'>
            <div className='footer-widget widget-contact'>
              <div className='widget-top'>
                <h3 className='widget-title'>Liên hệ</h3>
              </div>
              <div className='widget-body'>
                <ul className='list-unstyled'>
                  <li><i className='fa fa-location-arrow' /> {Setting.companyAddress}</li>
                  <li><i className='fa fa-phone' /> <a href={'tel:' + Setting.phone}>{Setting.phone}</a>
                    <br /> <a href={'tel:' + Setting.phone1}>{Setting.phone1}</a></li>
                  <li><i className='fa fa-phone' /> {Setting.fax}</li>
                  <li><i className='fa fa-envelope-o' />
                    <a href={'mailto:' + Setting.companyEmail + '?subject=Khách hàng Liên hệ&body=Kính gửi ' + Setting.companyName + '...Mong phản hồi sớm!'}>
                      {Setting.companyEmail}
                    </a>
                  </li>
                  <li><i className='fa fa-skype' /><a href={'skype:' + Setting.Skype + '?call'}>Call Me</a> </li>
                  <li><i><img src='/images/zalo-logo.png' /></i><a href={'http://zalo.me/' + Setting.Zalo}> Call Me</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className='col-sm-6'>
            <div className='footer-widget widget-newsletter'>
              <div className='widget-top'>
                <h3 className='widget-title'>Nhận thông tin</h3>
              </div>
              <div className='widget-body'>
                <Email />
                <p>Chuyên cung cấp thiết bị điện Trung - Hạ thế.<br />Hãy theo dõi chúng tôi:</p>
                <ul className='social'>
                  <li>
                    <a target='_blank' className='btn-facebook' href={Setting.FB}><i className='fa fa-facebook-square' /></a>
                  </li>
                  <li>
                    <a target='_blank' className='btn-twitter' href={Setting.Twitter}><i className='fa fa-twitter-square' /></a>
                  </li>
                  <li>
                    <a target='_blank' className='btn-linkedin' href={Setting.Linkedin}><i className='fa fa-linkedin-square' /></a>
                  </li>
                  <li>
                    <a target='_blank' className='btn-google-plus' href={Setting.GooglePlus}><i className='fa fa-google-plus-square' /></a>
                  </li>
                  <li>
                    <a target='_blank' className='btn-instagram' href={Setting.Instagram}><i className='fa fa-instagram' /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='footer-bottom'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-3 col-sm-3'>
            <div className='footer-col'>
              <p>Bản quyền @Việt Trung Thông.</p>
            </div>
          </div>
          <div className='col-md-6 col-sm-6'>
            <div className='footer-col'>
              <div className='navi'>
                <ul id='footer-menu' className=''>
                  <li><a href='privacy.html' /></li>
                  <li><a href='terms-and-conditions.html' /></li>
                  <li><a href='contact-us.html' /></li>
                </ul>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-sm-3'>
            <div className='footer-col foot-social'>
              <p>
                Dõi theo
                <a target='_blank' className='btn-facebook' href={Setting.FB}><i className='fa fa-facebook-square' /></a>

                <a target='_blank' className='btn-twitter' href={Setting.Twitter}><i className='fa fa-twitter-square' /></a>

                <a target='_blank' className='btn-linkedin' href={Setting.Linkedin}><i className='fa fa-linkedin-square' /></a>

                <a target='_blank' className='btn-google-plus' href={Setting.GooglePlus}><i className='fa fa-google-plus-square' /></a>

                <a target='_blank' className='btn-instagram' href={Setting.Instagram}><i className='fa fa-instagram' /></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

// Footer.propTypes = {
//     counter: PropTypes.number.isRequired,
//     increment: PropTypes.func.isRequired,
//     doubleAsync: PropTypes.func.isRequired,
// }

export default Footer



// WEBPACK FOOTER //
// ./src/components/_partial/Footer.js